import {
  call,
  put,
  takeLatest,
  all,
  select,
  takeEvery,
  take,
  cancel,
  cancelled
} from 'redux-saga/effects'
import { isArray, isString, isObject, isFunction } from 'lodash'
import {
  updateData,
  toggleLoading,
  REQUEST_DATA,
  updateDeviceProperties,
  updateUserGroup,
  REQUEST_DEVICE_PROPERTIES,
  REQUEST_USER_GROUP,
  getDataDownload,
  showDataDownloadFailed,
  updateDataProgress,
  finishDownload,
  REQUEST_DOWNLOAD_EXCEL,
  FINISH_DOWNLOAD,
  GET_DATA_DOWNLOAD,
  RESUME_DOWNLOAD_PROGRESS,
  REQUEST_CLOSE_DOWNLOAD_EXCEL,
  closeDownloadExcel,
  requestCloseDownload,
  updateChildrenOfUser,
  REQUEST_CHILDREN_OF_USER,
  updatePropertyChildrenUser
} from '../actions/devicesPage.action'
import {
  getRelationChildren,
  getAllRelationUser
} from '../apis/devicesPage.api'
import { getDeviceTypeByDeviceIds } from '../apis/deviceType.api'
import {
  getDevicePropertyByDeviceIds,
  getAllDeviceProperties
} from '../apis/deviceProperty.api'
import { getObjectFromArray } from '../utils/object'
import {
  getSignalCode,
  getVoltage,
  getCurrent,
  getSignalType,
  getRiverBranch,
  getPhoneNumber,
  getBlinkingType,
  getStatus,
  getLocationSetup,
  getLocation,
  getLocationSetupRadius,
  getLightPower
} from '../routes/DevicesPage/modules/utils'
import {
  SIGNAL_CODE_KEY,
  VOLTAGE,
  CURRENT,
  SIGNAL_TYPE,
  RIVER_BRANCH,
  MY_PHONE_NUMBER,
  BLINKING_TYPE,
  SIGNAL_STATUS,
  LOCATION_SETUP,
  LOCATION_RADIUS_SETUP,
  LIGHT_POWER,
  PRODUCTION_NUMBER,
  DESCRIPTION
} from '../constants/propertyKeys'
import Util from '../utils/Util'
import moment, { isDate } from 'moment'
import XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { actions as toastrActions } from 'react-redux-toastr'
import { getMaxRole } from '../utils/getRole'
import { ROLE_RATIO, ROLE_MAP } from '../constants/role'
import { getDevices as getDevicesApi } from '../apis/devices.api'
import { getUsers } from '../apis/user'
import { getUserRelation } from '../routes/UsersPage/modules/apis/relationUsers'

var excelAll = false;
const propertiesUpdate = [
  {name: "Day", display: "Thời gian gps ban ngày"},
  {name: "Dty", display: "Độ sáng tối đa"},
  {name: "Fls", display: "Bộ nhớ ngoài"},
  {name: "GPS", display: "Kiểu check GPS"},
  {name: "Nit", display: "Thời gian gps ban đêm"},
  {name: "Opt", display: "Thời gian sáng tối đa"},
  {name: "Sed", display: "Thời gian gửi tin"},
  {name: "imei", display: "IMEI"},
  {name: "Dal", display: "Cảnh báo rời vị trí"},
]

function* getDevices({
  pageSize,
  page,
  sorted,
  filtered,
  isGetRelationDevice
}) {
  const { roles } = yield select(state => state.user)
  const maxRole = getMaxRole(roles)
  let isAdmin = ROLE_RATIO[maxRole] > ROLE_RATIO[ROLE_MAP.USER]
  if (isGetRelationDevice) isAdmin = false
  const api = isAdmin ? getDevicesApi : getRelationChildren
  yield put(toggleLoading())
  try {
    const { childrenDeviceInfo, data, limit, total } = yield call(
      api,
      pageSize,
      page,
      sorted,
      filtered
    )
    let getParenInfo = null
    let parentOfDeviceMapped = {}
    const dataSource = isAdmin ? data : childrenDeviceInfo
    if (!isAdmin) {
      parentOfDeviceMapped = getObjectFromArray(
        data.filter(item => item.childrenType === 'device'),
        element => element.childrenId
      )
      getParenInfo = id => {
        const notFoundText = 'Chưa xếp nhóm'
        if (!parentOfDeviceMapped[id]) return notFoundText
        if (
          !isArray(parentOfDeviceMapped[id].parentsInfo) ||
          parentOfDeviceMapped[id].parentsInfo.length === 0
        )
          return notFoundText
        return parentOfDeviceMapped[id].parentsInfo[0]
      }
    }
    const deviceTypeIds = dataSource.map(item => item.deviceTypeId).filter((v, i, s)=> s.indexOf(v) === i)
    const deviceTypes = yield call(getDeviceTypeByDeviceIds, deviceTypeIds)
    const devicePropertyIds = deviceTypes.data.reduce(
      (prevValue, currentValue) => {
        const { properties } = currentValue
        const nextValue = [...prevValue]
        if (!isArray(properties)) return nextValue
        for (let index = 0; index < properties.length; index++) {
          const element = properties[index]
          const { propertyId } = element
          if (!propertyId) continue
          if (nextValue.includes(propertyId)) continue
          nextValue.push(propertyId)
        }
        return nextValue
      },
      []
    )
    const deviceProperties = yield call(
      getDevicePropertyByDeviceIds,
      devicePropertyIds
    )
    const devicePropertiesMapped = getObjectFromArray(
      deviceProperties.data,
      element => element._id
    )
    const deviceTypesAddedProperty = deviceTypes.data.map(item => {
      return {
        ...item,
        properties: item.properties.map(i => ({
          ...i,
          propertyInfo: devicePropertiesMapped[i.propertyId] || {}
        }))
      }
    })
    const deviceTypesMapped = getObjectFromArray(
      deviceTypesAddedProperty,
      element => element._id
    )
    const fullDevices = dataSource.map(item => {
      const { propertiesValue = {} } = item
      const deviceTypeMapped = deviceTypesMapped[item.deviceTypeId] || {}
      const propertiesOfDeviceType = deviceTypeMapped.properties.map(item => ({
        ...item,
        propertyValue:
          propertiesValue[item.name] !== undefined
            ? propertiesValue[item.name]
            : ''
      }))
      const propertiesMapped = getObjectFromArray(
        propertiesOfDeviceType,
        element => element.name
      )

      // for parent
      let companyInfo
      let parentInfo
      if (isAdmin) {
        const companyIdInfo =
          item.relationsInfo &&
          item.relationsInfo.filter(item => item.roles.includes(ROLE_MAP.ADMIN))
        const parentIdInfos =
          item.relationsInfo &&
          item.relationsInfo.filter(
            item =>
              item.roles.includes(ROLE_MAP.USER) &&
              !item.roles.includes(ROLE_MAP.ADMIN)
          )
        companyInfo =
          companyIdInfo &&
          companyIdInfo.length > 0 &&
          item.parentsInfo.find(
            item =>
              // eslint-disable-next-line
              item._id == companyIdInfo[0].parentId
          )
        parentInfo =
          parentIdInfos &&
          parentIdInfos.length > 0 &&
          item.parentsInfo.find(
            item =>
              // eslint-disable-next-line
              item._id == parentIdInfos[0].parentId
          )
      }
      return {
        ...item,
        deviceTypeMapped,
        parentsInfo: isFunction(getParenInfo) ? getParenInfo(item._id) : null,
        parentInfo,
        companyInfo,
        relationInfo: parentOfDeviceMapped[item._id],
        propertiesMapped
      }
    })
    yield put(updateData(fullDevices, Math.ceil(total / limit), total))
  } catch (error) {
    console.log(error)
  } finally {
    yield put(toggleLoading())
  }
}

function* getDeviceProperties() {
  try {
    const deviceProperties = yield call(getAllDeviceProperties)
    const devicePropertiesMapped = getObjectFromArray(
      deviceProperties.data,
      element => element.code
    )
    yield put(updateDeviceProperties(devicePropertiesMapped))
  } catch (error) {
    console.log(error)
  }
}

function* getUserGroup({ isGetTotal, isAdmin }) {
  try {
    let userData = null
    if (isAdmin) {
      const res = yield call(getUsers, -1, 0,[],[{id:'group',value:true}])
      userData = res.map(item => ({ ...item, isCompany: true }))
    } else {
      const { childrenUserInfo } = yield call(getAllRelationUser)
      userData = childrenUserInfo
    }
    const childrenUserInfoMapped = getObjectFromArray(
      userData.map(item => ({
        ...item,
        id: item._id
      })),
      element => element._id
    )
    if (isGetTotal) {
      for (let i = 0; i < userData.length; i++) {
        const { _id } = userData[i]
        const { total } = yield call(getRelationChildren, 0, 0, null, [
          {
            id: 'parentId',
            value: _id
          }
        ])
        childrenUserInfoMapped[_id].total = total
        childrenUserInfoMapped[_id].children = isAdmin ? [] : undefined
      }
    }
    yield put(updateUserGroup(childrenUserInfoMapped))
  } catch (error) {
    console.log(error)
  }
}

function* requestDownloadExcel({ total, filtered, all }) {
  const limit = 100
  const page = 0
  const initialData = []
  excelAll = all;
  yield put(updateDataProgress(initialData, limit, page, total, filtered))
  yield put(getDataDownload())
}

function* getDataDownloadExcel() {
  const { limit, page, filtered = [] } = yield select(
    state => state.devicesPage.download
  )
  const { roles } = yield select(state => state.user)
  const maxRole = getMaxRole(roles)
  let isAdmin = ROLE_RATIO[maxRole] > ROLE_RATIO[ROLE_MAP.USER]
  const api = isAdmin ? getDevicesApi : getRelationChildren
  try {
    const {
      childrenDeviceInfo,
      data,
      limit: resLimit,
      total: resTotal,
      skip: resSkip
    } = yield call(api, limit, page, null, filtered)
    let getParentInfo = null
    let parentOfDeviceMapped = {}
    const dataSource = isAdmin ? data : childrenDeviceInfo
    if (!isAdmin) {
      parentOfDeviceMapped = getObjectFromArray(
        data.filter(item => item.childrenType === 'device'),
        element => element.childrenId
      )
      getParentInfo = id => {
        const notFoundText = 'Chưa xếp nhóm'
        if (!parentOfDeviceMapped[id]) return notFoundText
        if (
          !isArray(parentOfDeviceMapped[id].parentsInfo) ||
          parentOfDeviceMapped[id].parentsInfo.length === 0
        )
          return notFoundText
        return parentOfDeviceMapped[id].parentsInfo[0]
      }
    }
    const deviceTypeIds = dataSource.map(item => item.deviceTypeId).filter((v, i, s)=> s.indexOf(v) === i)
    const deviceTypes = yield call(getDeviceTypeByDeviceIds, deviceTypeIds)
    const devicePropertyIds = deviceTypes.data.reduce(
      (prevValue, currentValue) => {
        const { properties } = currentValue
        const nextValue = [...prevValue]
        if (!isArray(properties)) return nextValue
        for (let index = 0; index < properties.length; index++) {
          const element = properties[index]
          const { propertyId } = element
          if (!propertyId) continue
          if (nextValue.includes(propertyId)) continue
          nextValue.push(propertyId)
        }
        return nextValue
      },
      []
    )
    const deviceProperties = yield call(
      getDevicePropertyByDeviceIds,
      devicePropertyIds
    )
    const devicePropertiesMapped = getObjectFromArray(
      deviceProperties.data,
      element => element._id
    )
    const deviceTypesAddedProperty = deviceTypes.data.map(item => {
      return {
        ...item,
        properties: item.properties.map(i => ({
          ...i,
          propertyInfo: devicePropertiesMapped[i.propertyId] || {}
        }))
      }
    })
    const deviceTypesMapped = getObjectFromArray(
      deviceTypesAddedProperty,
      element => element._id
    )
    const result = dataSource.map(item => {
      const parentsInfo = getParentInfo ? getParentInfo(item._id) : null
      const { propertiesValue = {} } = item
      const deviceTypeMapped = deviceTypesMapped[item.deviceTypeId] || {}
      const propertiesOfDeviceType = deviceTypeMapped.properties.map(item => ({
        ...item,
        propertyValue: propertiesValue[item.name] || ''
      }))
      const propertiesMapped = getObjectFromArray(
        propertiesOfDeviceType,
        element => element.name
      )
      const locationSetup = getLocationSetup(propertiesMapped[LOCATION_SETUP])
      const location = getLocation(item.location)
      const tmp = new Date(item.updatedAt)
      let updatedAt = ''
      if (isDate(tmp)) {
        updatedAt = moment(tmp).format('DD-MM-YYYY')
      }
      const signalStatus = getStatus(propertiesMapped[SIGNAL_STATUS])
      var obj = {
        // 'Trạng thái': item.status,
        'Mã báo hiệu': getSignalCode(propertiesMapped[SIGNAL_CODE_KEY]),
        'Điện áp': getVoltage(propertiesMapped[VOLTAGE]),
        'Dòng điện': getCurrent(propertiesMapped[CURRENT]),
        'Loại BH': getSignalType(propertiesMapped[SIGNAL_TYPE]),
        'Tuyến sông': getRiverBranch(propertiesMapped[RIVER_BRANCH]),
        'Điện thoại': getPhoneNumber(propertiesMapped[MY_PHONE_NUMBER]),
        'Kiểu chớp': getBlinkingType(propertiesMapped[BLINKING_TYPE]),
        'Cảnh báo': isObject(signalStatus) ? signalStatus.name : 'Mất tín hiệu',
        'Tiết kiệm điện năng': item.propertiesValue.Cau ? (item.propertiesValue.Cau === 0 ? 'Tắt' : 'Bật') : '',
        'Tọa độ cài đặt': isObject(locationSetup)
          ? locationSetup.display
          : locationSetup,
        'Toạ độ': isObject(location) ? location.display : location,
        'Cập nhật': updatedAt,
        // 'Bán kính vị trí cài đặt': getLocationSetupRadius(
        //   propertiesMapped[LOCATION_RADIUS_SETUP]
        // ),
        // 'Công suất chiếu sáng': getLightPower(propertiesMapped[LIGHT_POWER]),
        'Phiên bản phần cứng': item.hardwareVersion,
        'Phiên bản phần mềm': item.firmwareVersion,
        'Mã sản xuất': item.propertiesValue && item.propertiesValue[PRODUCTION_NUMBER],
        'Mô tả': item.propertiesValue && item.propertiesValue[DESCRIPTION]
      }
      if(excelAll){
        obj = {
          ...obj,
          'Trạng thái': item.status,
          'Bán kính vị trí cài đặt': getLocationSetupRadius(propertiesMapped[LOCATION_RADIUS_SETUP]),
          'Công suất chiếu sáng': getLightPower(propertiesMapped[LIGHT_POWER]),
        }
        propertiesUpdate.forEach((e, i) => {
          var x = Util.getPropertyValueInfo(propertiesMapped[e.name] && propertiesMapped[e.name].propertyValue,
            propertiesMapped[e.name] && propertiesMapped[e.name].propertyInfo);
          obj[e.display] = x.name;
        })
      }
      if (!isAdmin) {
        obj['Trạm quản lý'] = isString(parentsInfo)
          ? parentsInfo
          : parentsInfo.username
      }
      return obj
    })
    yield put(updateDataProgress(result, resLimit, page + 1, resTotal))
    //Check download completed
    if (resSkip + result.length >= resTotal) {
      //Download completed
      yield put(finishDownload())
    } else {
      //Download not completed
      yield put(getDataDownload())
    }
  } catch (error) {
    console.log(error)
    yield put(showDataDownloadFailed(error))
  } finally {
    if (yield cancelled()) console.log('Download is stopped')
  }
}

function* watchGetDataDownloadExcel() {
  while (true) {
    const bgTask = yield takeEvery(GET_DATA_DOWNLOAD, getDataDownloadExcel)
    yield take(REQUEST_CLOSE_DOWNLOAD_EXCEL)
    yield cancel(bgTask)
    yield put(closeDownloadExcel())
  }
}

function* handleFinishDownload() {
  const { data } = yield select(state => state.devicesPage.download)
  var header = [
    'Trạm quản lý',
    'Mã báo hiệu',
    'Điện áp',
    'Dòng điện',
    'Loại BH',
    'Tuyến sông',
    'Điện thoại',
    'Kiểu chớp',
    'Cảnh báo',
    'Tiết kiệm điện năng',
    'Tọa độ cài đặt',
    'Toạ độ',
    'Cập nhật',
    'Phiên bản phần cứng',
    'Phiên bản phần mềm',
    'Mã sản xuất',
    'Mô tả'
  ];
  if(excelAll){
    header = [
      ...header,
      'Trạng thái',
      'Bán kính vị trí cài đặt',
      'Công suất chiếu sáng',
    ]
    propertiesUpdate.forEach(e => {
      header.push(e.display);
    })
  }
  const ws = XLSX.utils.json_to_sheet(data, {header})
  const wopts = { bookType: 'xlsx', bookSST: false, type: 'array' }
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, ws, 'DS BH')
  const wbout = XLSX.write(workbook, wopts)
  saveAs(
    new Blob([wbout], { type: 'application/octet-stream' }),
    `Danh_sach_BH_${moment().format('HH:mm:ss DD-MM-YYYY')}.xlsx`
  )
  yield put(requestCloseDownload())
  yield put(
    toastrActions.add({
      id: `${moment().format('HH:mm:ss DD-MM-YYYY')}-download-excel-success`, // If not provided we will add one.
      type: 'success',
      title: 'Xuất dữ liệu Excel',
      position: 'top-right',
      message: 'Xuất dữ liệu thành công!'
    })
  )
}

function* resumeDownloadProgress() {
  yield put(showDataDownloadFailed(null))
  yield put(getDataDownload())
}

function* getChildrenOfUser({ parentId, toggled }) {
  yield put(updatePropertyChildrenUser(parentId, 'loading', true))
  try {
    const { childrenUserInfo } = yield call(
      getUserRelation,
      parentId,
      -1,
      0,
      [],
      []
    )
    for (let i = 0; i < childrenUserInfo.length; i++) {
      const { _id } = childrenUserInfo[i]
      const { total } = yield call(getRelationChildren, 1, 0, null, [
        {
          id: 'parentId',
          value: _id
        }
      ])
      childrenUserInfo[i].total = total
    }
    if (childrenUserInfo.length > 0)
      yield put(
        updateChildrenOfUser(
          parentId,
          childrenUserInfo.map(item => ({
            ...item
          }))
        )
      )
    else yield put(updatePropertyChildrenUser(parentId, 'children', undefined))
  } catch (error) {
    console.log(error)
  } finally {
    yield put(updatePropertyChildrenUser(parentId, 'loading', false))
  }
}

export default function* watchRequestDevices() {
  yield all([
    takeLatest(REQUEST_DATA, getDevices),
    takeLatest(REQUEST_DEVICE_PROPERTIES, getDeviceProperties),
    takeLatest(REQUEST_USER_GROUP, getUserGroup),
    takeLatest(REQUEST_DOWNLOAD_EXCEL, requestDownloadExcel),
    takeLatest(FINISH_DOWNLOAD, handleFinishDownload),
    takeEvery(RESUME_DOWNLOAD_PROGRESS, resumeDownloadProgress),
    watchGetDataDownloadExcel(),
    takeLatest(REQUEST_CHILDREN_OF_USER, getChildrenOfUser)
  ])
}
